"use client";

import { usePlayerLook } from "@/lib/profile/hooks";
import { cn } from "@/lib/cn";
import { Avatar } from "@/components/ui/primitives";

/* A player's face: the profile image they chose (/admin -> Profile images),
   or the lettered disc everyone had before, when they chose none. */
export function ProfileAvatar({
  accountId,
  name,
  size,
  glow,
  className,
}: {
  accountId: string | null | undefined;
  name: string;
  size: number;
  glow?: boolean;
  className?: string;
}) {
  const look = usePlayerLook(accountId);
  const src = look.data?.avatar;

  if (!src) {
    return <Avatar name={name} size={size} glow={glow} />;
  }

  return (
    <span
      className={cn("relative inline-block shrink-0 overflow-hidden rounded-full bg-elevation-3", glow && "glow-brand-soft", className)}
      style={{ width: size, height: size }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- admin uploads are served from the content API */}
      <img src={src} alt="" width={size} height={size} className="h-full w-full object-cover" />
    </span>
  );
}
